import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { unwrapBlobError } from '@/Network/Requests/blobError'

/**
 * Download da evidência de check.
 *
 * Vive fora do `StationService` porque o endpoint saiu do módulo `stations` no
 * backend: a evidência passou a ter módulo próprio, para que a fila de auditoria
 * possa servi-la com a permissão do auditor sem criar dependência circular entre
 * os módulos.
 *
 * O `stationId` continua na rota: é ele que resolve a permissão e é ele que o
 * backend compara para garantir que a evidência pertence àquele plantão.
 */
export default class DoctorCheckEvidenceService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/doctor-check-evidence'
  }

  /**
   * Baixa o conteúdo de uma evidência de check via endpoint autenticado que
   * evita expor a URL crua do Azure Blob. Retorna o Blob para que o caller
   * possa criar uma blob URL local (ou direct download) sem o arquivo passar
   * por qualquer URL pública.
   */
  async downloadCheckEvidenceFile(stationId: number, evidenceId: number): Promise<Blob> {
    try {
      const { data } = await request.get<Blob>(
        this.getCompletePath(`/${stationId}/${evidenceId}/file`),
        undefined,
        undefined,
        'blob'
      )
      return data
    } catch (e) {
      // responseType 'blob': o body JSON de erro vem num Blob — parse antes.
      throw this.handleError(
        await unwrapBlobError(e),
        'Não foi possível baixar a evidência de registro'
      )
    }
  }
}
